var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#C6C6C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_175)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8685 9C12.0752 9 9 12.0752 9 15.8685C9 19.6619 12.0752 22.7371 15.8685 22.7371C17.4736 22.7371 18.95 22.1866 20.1193 21.2641L25.6317 26.7765C25.9298 27.0745 26.413 27.0745 26.711 26.7765C27.009 26.4784 27.009 25.9952 26.711 25.6972L21.2059 20.1921C22.1634 19.0115 22.7371 17.507 22.7371 15.8685C22.7371 12.0752 19.6619 9 15.8685 9ZM10.5263 15.8685C10.5263 12.9181 12.9181 10.5263 15.8685 10.5263C18.819 10.5263 21.2107 12.9181 21.2107 15.8685C21.2107 18.819 18.819 21.2107 15.8685 21.2107C12.9181 21.2107 10.5263 18.819 10.5263 15.8685Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDisabled);
export default __webpack_public_path__ + "static/media/Search_disabled.03b7e385d67ec0e8efe4b88e934b8e63.svg";
export { ForwardRef as ReactComponent };